import RolesScreen from "../../Screen/IT/Roles/RolesScreen";
import SesionesScreen from "../../Screen/IT/Sesiones/SesionesScreen";
import AccesosScreen from "../../Screen/IT/Accesos/AccesosScreen";
import NewsScreen from "../../Screen/IT/News/NewsScreen";
import ListaCorreosScreen from "../../Screen/IT/ListaCorreo/ListaCorreosScreen";
import MenuScreen from "../../Base/Screens/IT/Menu/MenuScreen";
import UsuariosScreen from "../../Screen/IT/Usuarios/UsuariosScreen";
import TestITScreen from "../../Base/Screens/IT/Test/TestITScreen";
import RutasScreen from "../../Base/Screens/IT/Rutas/RutasScreen";
import MarcasScreen from "../../Base/Screens/IT/Marcas/MarcasScreen";
import TipoDispositivo from "../../Base/Screens/IT/TipoDispositivo/TipoDispositivoScreen";
import RedScreen from "../../Base/Screens/IT/Red/RedScreen";
import VideoScreen from "../../Base/Screens/IT/Red/Video/VideoScreen";
import TelefoniaScreen from "../../Base/Screens/IT/Red/Telefonia/TelefoniaScreen";
import EstadosScreen from "../../Screen/IT/Estados/EstadosScreen";
import MetricasScreen from "../../Base/Screens/IT/Metricas/MetricasScreen";
import RegistroMetricasScreen from "../../Base/Screens/IT/Metricas/RegistroMetricasScreen";
import ActualizacionAppScreen from "../../Base/Screens/IT/ActualizacionesApp/ActualizacionAppScreen";

export const ITRoutes = [
  {
    path: 'IT/Roles',
    permiso: 6,
    element: <RolesScreen />
  },
  {
    path: 'IT/Usuarios',
    permiso: 7,
    element: <UsuariosScreen />
  },
  {
    path: 'IT/Menu',
    permiso: 11,
    element: <MenuScreen />
  },
  {
    path: 'IT/Sesiones',
    permiso: 12,
    element: <SesionesScreen />
  },
  {
    path: 'IT/News',
    permiso: 30,
    element: <NewsScreen />
  },
  {
    path: 'IT/Accesos',
    permiso: 39,
    element: <AccesosScreen />
  },
  {
    path: 'IT/ListaCorreos',
    permiso: 53,
    element: <ListaCorreosScreen />
  },
  {
    path: 'IT/Test',
    permiso: 91,
    element: <TestITScreen />
  },
  {
    path: 'IT/Dispositivos/Rutas',
    permiso: 96,
    element: <RutasScreen />
  },
  {
    path: 'IT/Dispositivos/Marcas',
    permiso: 98,
    element: <MarcasScreen />
  },
  {
    path: 'IT/Dispositivos/TipoDispositivo',
    permiso: 99,
    element: <TipoDispositivo />
  },
  {
    path: 'IT/Dispositivos/Red',
    permiso: 101,
    element: <RedScreen />
  },
  {
    path: 'IT/Dispositivos/Video',
    permiso: 102,
    element: <VideoScreen />
  },
  {
    path: 'IT/Dispositivos/Telefonia',
    permiso: 103,
    element: <TelefoniaScreen />
  },
  {
    path: 'IT/Dispositivos/ActualizacionApp',
    permiso: 140,
    element: <ActualizacionAppScreen />
  },
  {
    path: 'IT/Status',
    permiso: 132,
    element: <EstadosScreen />
  },
  {
    path: 'IT/Metricas',
    permiso: 137,
    element: <MetricasScreen />
  },
  {
    path: 'IT/RegistroMetricas',
    permiso: 138,
    element: <RegistroMetricasScreen />
  },
]

export default ITRoutes;